import { render } from "./ThematicCardModal.component.vue?vue&type=template&id=ca817bc6"
import script from "./ThematicCardModal.component.vue?vue&type=script&lang=js"
export * from "./ThematicCardModal.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/thematicCard/ThematicCardModal.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca817bc6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca817bc6', __exports__)) {
    console.log('reload')
    api.reload('ca817bc6', __exports__)
  }
  
  module.hot.accept("./ThematicCardModal.component.vue?vue&type=template&id=ca817bc6", () => {
    console.log('re-render')
    api.rerender('ca817bc6', render)
  })

}


export default __exports__